import ubisoftOverlayService from 'modules/ubisoft-overlay-service/service';
import {
    LOAD_UBISOFT_OVERLAY_DONE,
    LOAD_UBISOFT_OVERLAY_ERROR,
    INITIALIZE_UBISOFT_OVERLAY_DONE
} from './ubisoft-connect-overlay-provider.constants';
import { WEBSITE_MODE } from '@sitegen/common/constants/config';
import { Dispatch } from 'types/dispatch';

export const setInitOverlayDone = () => ({ type: INITIALIZE_UBISOFT_OVERLAY_DONE });
export const setLoadOverlayDone = () => ({ type: LOAD_UBISOFT_OVERLAY_DONE });
export const setLoadOverlayError = () => ({ type: LOAD_UBISOFT_OVERLAY_ERROR });

export const loadUbisoftConnectOverlay = () => async (dispatch: Dispatch, getState: Function) => {
    const state = getState();
    const envName = state.config.envName;
    const mode: WEBSITE_MODE = state.config.mode;

    const onError = () => dispatch(setLoadOverlayError());
    const onSuccess = () => dispatch(setLoadOverlayDone());
    const onInit = () => dispatch(setInitOverlayDone());

    try {
        return await ubisoftOverlayService.install({ mode, envName }, onSuccess, onInit);
    } catch (e) {
        return onError();
    }
};
